import { useState } from "react";
import { heroStats } from "@/mocks/home";

const quickTags = ["合约风波", "直播失言", "退票争议", "旧访谈", "回应声明"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const [hint, setHint] = useState("");

  const handleSearch = () => {
    const value = keyword.trim();
    setHint(value ? `已定位到「${value}」相关的归档条目（展示态）` : "请输入关键词，例如某个名字或事件");
  };

  return (
    <section id="top" className="pt-28 md:pt-36 pb-14 md:pb-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 h-8 px-3 rounded-full bg-accent-100 text-accent-900 text-xs tracking-wide">
              <i className="ri-archive-2-line" />
              旧瓜补课 · 完整回看
            </span>

            <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-[52px] font-bold leading-[1.2] text-foreground-950">
              黑料在线
              <span className="block mt-2 text-primary-600">把散落的事件，按时间线重新排好</span>
            </h1>

            <p className="mt-6 max-w-2xl text-base md:text-lg leading-8 text-foreground-700">
              这里是<strong className="font-semibold text-foreground-900">黑料在线历史记录</strong>的归档入口：把零散的线索按日期整理成完整记录，再打包成可直接翻看的
              <strong className="font-semibold text-foreground-900">往期合集</strong>。想补全某件事的前后因果，直接从时间线往下翻就行，不用临时到处找。
            </p>

            <div className="mt-8 bg-background-100 border border-background-200 rounded-lg p-2">
              <div className="flex flex-col sm:flex-row gap-2">
                <div className="flex items-center flex-1 gap-2 px-3 h-11 rounded-md bg-background-50 border border-background-200">
                  <i className="ri-search-line text-secondary-500" />
                  <input
                    type="text"
                    value={keyword}
                    onChange={(event) => setKeyword(event.target.value)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") handleSearch();
                    }}
                    placeholder="输入名字 / 事件 / 关键词，检索历史记录"
                    className="w-full text-sm text-foreground-900 placeholder:text-foreground-400 bg-transparent outline-none"
                    name="hero_keyword"
                  />
                </div>
                <button
                  type="button"
                  onClick={handleSearch}
                  className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  开始补课
                </button>
              </div>
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="text-xs text-foreground-500">常被检索：</span>
              {quickTags.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => setKeyword(tag)}
                  className="h-7 px-3 rounded-full border border-background-300 text-xs text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {tag}
                </button>
              ))}
            </div>

            {hint && <p className="mt-3 text-xs text-primary-600">{hint}</p>}

            <dl className="mt-10 grid grid-cols-3 gap-4 max-w-xl">
              {heroStats.map((stat) => (
                <div key={stat.label} className="border-l border-background-300 pl-4">
                  <dt className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {stat.value}
                  </dt>
                  <dd className="mt-1 text-xs text-foreground-600">{stat.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <figure className="relative">
              <div className="w-full h-[300px] md:h-[420px] lg:h-[480px] rounded-lg overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20style%20abstract%20collage%20with%20layered%20paper%20cutouts%20and%20grainy%20texture%2C%20warm%20cream%20and%20brick%20red%20palette%2C%20vintage%20archive%20folder%20aesthetic%2C%20soft%20natural%20light%2C%20muted%20noir%20mood%2C%20no%20text%2C%20high%20detail&width=800&height=1000&seq=hl-hero-cover-01&orientation=portrait"
                  alt="黑料在线历史记录归档封面"
                  title="黑料在线历史记录与往期合集"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <figcaption className="mt-4 flex items-start gap-3 text-xs text-foreground-600">
                <span className="mt-0.5 w-6 h-6 shrink-0 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                  <i className="ri-file-list-3-line" />
                </span>
                <span className="leading-6">
                  每期归档都会标注时间、类型与可查证程度，往期合集按主题打包，方便一次补完。
                </span>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}